import { buildContentQuery } from './Content'
import { store } from '../../App'

export const FAIL_FETCH = 'FAIL_FETCH'

export const FETCH_PUSH_NOTIFICATIONS = 'FETCH_PUSH_NOTIFICATIONS'
export const FETCH_SEARCH_TERMS = 'FETCH_SEARCH_TERMS'
export const FETCH_BANNER_CONTENT = 'FETCH_BANNER_CONTENT'

export const LOAD_PUSH_NOTIFICATIONS = 'LOAD_PUSH_NOTIFICATIONS'
export const LOAD_SEARCH_TERMS = 'LOAD_SEARCH_TERMS'
export const LOAD_BANNER_CONTENT = 'LOAD_BANNER_CONTENT'

/**
  * failFetch
  * @desc Fail Fetch Action Generator
  * @param {Object} error
  * @return {action} failFetchAction
*/
export function failFetch (error) {
  return { type: FAIL_FETCH, error }
}

/**
  * fetchPushNotifications
  * @param {string} ID
  * @param {timestamp} start
  * @param {timestamp} end
  * @param {Object} options
  * @return {action} fetchPushNotificationsAction
*/
export function fetchPushNotifications (ID, start, end, options) {
  const query = { accountId: ID, startDate: start, endDate: end }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    // query['groupIds'] = []
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
    query.groupIds = ['AllGROUPS']
  }
  return { type: FETCH_PUSH_NOTIFICATIONS, query }
}

/**
  * fetchSearchTerms
  * @param {string} ID
  * @param {timestamp} start
  * @param {timestamp} end
  * @param {Object} options
  * @return {action} fetchSearchTermsAction
*/
export function fetchSearchTerms (ID, start, end, options) {
  const query = { accountId: ID, startDate: start, endDate: end }
  if (options.appType) {
    query.appType = options.appType
  } else {
    query.appType = 'ALL'
  }
  if (options.limit) {
    query.limit = options.limit
  }
  if (options.offset) {
    query.offset = options.offset
  }
  if (options.profile && options.profile[0].length > 0) {
    query.appProfileIds = options.profile
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    query.appProfileIds = store.getState().filterSources.profiles.map(profile => profile._id)
  }
  if (options.group && options.group[0].length > 0) {
    query.groupIds = options.group
  } else {
    if (store.getState().filterSources.profiles[0]._id === '0') {
      return { type: FAIL_FETCH }
    }
    // query['groupIds'] = []
    // store.getState().filterSources.profiles.forEach((profile) => {
    //   query['groupIds'] = [...new Set([].concat(...[query['groupIds'], profile.groups]))]
    // })
    query.groupIds = ['AllGROUPS']
  }
  return { type: FETCH_SEARCH_TERMS, query }
}

/**
  * fetchBannerContent
  * @param {string} ID
  * @param {timestamp} start
  * @param {timestamp} end
  * @param {string} location
  * @param {Object} options
  * @return {action} fetchBannerContent
*/
export function fetchBannerContent (ID, start, end, location, options) {
  // (accountId: String!, startDate: DateTime!, endDate: DateTime!, location: ContentLocation!, limit: Int, offset: Int)
  let query = { accountId: ID, startDate: start, endDate: end, location }
  query = buildContentQuery(query, options)
  if (query.accountId) {
    return { type: FETCH_BANNER_CONTENT, query }
  }
  return { type: FAIL_FETCH, query }
}

/**
  * loadPushNotifications
  * @param {Object} data
  * @return {action} loadPushNotificationsAction
*/
export function loadPushNotifications (data) {
  return { type: LOAD_PUSH_NOTIFICATIONS, data }
}

/**
  * loadSearchTerms
  * @param {Object} data
  * @return {action} loadSearchTermsAction
*/
export function loadSearchTerms (data) {
  return { type: LOAD_SEARCH_TERMS, data }
}

/**
  * loadBannerContent
  * @param {Object} data
  * @return {action} loadBannerContentAction
*/
export function loadBannerContent (data) {
  return { type: LOAD_BANNER_CONTENT, data }
}
